// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__brkwD","section":"styles_section__kwNW6"};